import { DeviceSettings } from './types';
import portsApi from '../framework/ports/portsApi';

export default {
  getDeviceInfo: (): Promise<DeviceSettings> =>
    portsApi.invoke('DeviceDetection.getDeviceInfo'),
};
